import { render, staticRenderFns } from "./Candidatos.vue?vue&type=template&id=cf369a8e&scoped=true"
import script from "./Candidatos.vue?vue&type=script&lang=js"
export * from "./Candidatos.vue?vue&type=script&lang=js"
import style0 from "./Candidatos.vue?vue&type=style&index=0&id=cf369a8e&prod&scoped=true&lang=css"
import style1 from "./Candidatos.vue?vue&type=style&index=1&id=cf369a8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf369a8e",
  null
  
)

export default component.exports